import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { SMS_DEFAULT_REGISTRATION_SUCCESS, SMS_DEFAULT_USER_ALREADY_REGISTERED, SMS_DEFAULT_ANOTHER_USER_REGISTERED, SMS_DEFAULT_USER_MAXED_COUPON } from 'src/app/utils/constant';
import { HelperService, DialogService, AuthService } from 'src/app/services';
import { ConstantsHelper } from 'src/assets/constants/constants.helper';
import { MediaObserver } from '@angular/flex-layout';
import * as _ from 'lodash';

@Component({
  selector: 'esc-campaign-maintenance-detail',
  templateUrl: './campaign-maintenance-detail.component.html',
  styleUrls: ['./campaign-maintenance-detail.component.scss']
})
export class CampaignMaintenanceDetailComponent implements OnInit {
  @Input() detail;
  @Input() detailKeys1 = [];
  @Input() detailKeys2 = [];
  @Input() loadError;
  @Input() type;
  @Input() disableEdit;
  @Input() disableEditMessage;
  @Input() moduleCode;
  @Input() displayMode;
  @Output() edit = new EventEmitter;
  @Output() closeDetail = new EventEmitter;
  @Output() downloadFile = new EventEmitter;

  constructor(
    public helper: HelperService,
    public media: MediaObserver,
    public authService: AuthService,
    private dialogService: DialogService,
    ) { }

  public detailData;
  selectedTabIndex = 0;
  public constants = ConstantsHelper;
  private defaultSMSMessages = [
    {
      type: "REGISTRATION_SUCCESS",
      message: SMS_DEFAULT_REGISTRATION_SUCCESS
    },
    {
      type: "USER_ALREADY_REGISTERED",
      message: SMS_DEFAULT_USER_ALREADY_REGISTERED
    },
    {
      type: "ANOTHER_USER_REGISTERED",
      message: SMS_DEFAULT_ANOTHER_USER_REGISTERED
    },
    {
      type: "USER_MAXED_COUPON",
      message: SMS_DEFAULT_USER_MAXED_COUPON
    },
  ]
  
  ngOnInit() {
    // console.log(this.moduleCode)
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes.detail.currentValue)
    this.detailData = _.clone(changes.detail.currentValue);
    this.selectedTabIndex = 0;
  }

  close() {
    this.closeDetail.next(true);
  }

  modify() {
    if(this.disableEdit) {
      this.dialogService.openSnackBar(this.disableEditMessage);
      return;
    }
    this.edit.next(true);
  }

  displayFields(data, key) {
    return _.get(data, 'type') == _.toUpper(key) ? _.get(data, 'message') : this.defaultSMSMessages.map(e => { 
      if(e.type == _.toUpper(key)) {
        return e.message;
      }
    }).join('');
  }

  download() {
    this.downloadFile.next(_.get(this, 'detailData'));
  }
}